/* OO(2026-10-11) 確認役の指摘 2・3・7・8・9 と、会長の細かい直し

   ★なぜ shop2.js に書かないのか
   コネクタで送れる文字数は 16,384 までで、shop2.js は 16,953 文字あり送れません。
   ★サイズの cm は assets/shop7.js が受け持ちます（商品ごとの表から読むため）。
   読み込みは layout/theme.liquid の shop4.js のすぐ下に足してあります。

   ★2026-10-11 に外したもの（大事）
   「見出しだけで中身が空の枠を隠す」直しを入れていましたが、その枠の中に
   **商品説明（スタッフ着用サイズ表・▼SIZE・紹介文）も入っていた**ため、
   おすすめが空の商品では商品説明ごと消えてしまっていました。外しました。
   空の枠をどうしても詰めたい場合は、セクション全体ではなく
   「おすすめ商品の並びだけ」を狙う必要があります。 */
(function () {
  'use strict';

  var OODAY_END = new Date('2026-10-12T23:59:59+09:00').getTime();
  var OODAY_NOTE = 'OODAY｜10/12(月・祝)まで ログインすると、お会計で自動10%OFF';

  function isOldOrder() {
    var t = (document.querySelector('h1.product__title, h1') || {}).textContent || '';
    return /OLD\s*ORDER/i.test(t);
  }

  function isCart() {
    return location.pathname.indexOf('/cart') === 0;
  }

  /* 「会員さま」→「会員様」に統一（2026-10-11 会長）
     出てくる所が5か所あり（帯・商品ページの送料の欄・商品説明の発送の欄・
     カートの送料バー・フッター）、うち templates/product.json は
     文字数が多くてコネクタから送れません。そこで見えている字をまとめて直します。 */
  function fixSama() {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var v = node.nodeValue || '';
      if (v.indexOf('会員さま') < 0) continue;
      node.nodeValue = v.replace(/会員さま/g, '会員様');
    }
  }

  /* ---------------------------------------------------------------
     英語のまま残っていた見出しを日本語にする
     --------------------------------------------------------------- */
  var WORDS = [
    ['SIMILAR ITEMS', 'こちらもおすすめ'],
    ['YOU MAY ALSO LIKE', 'こちらもおすすめ'],
    ['RECENTLY VIEWED', '最近見た商品'],
    ['SHOPPING GUIDE', 'お買いもののご案内'],
    ['DESCRIPTION', '商品説明']
  ];

  function fixHeads() {
    document.querySelectorAll('h1, h2, h3, span').forEach(function (e) {
      if (e.children.length) return;
      var t = (e.textContent || '').trim().toUpperCase();
      for (var i = 0; i < WORDS.length; i += 1) {
        if (t === WORDS[i][0]) { e.textContent = WORDS[i][1]; return; }
      }
    });

    //   折りたたみの見出し（<summary class="accordion__button">Description</summary>）は
    //   中に開け閉めのアイコンが入っていて、上のやり方では届きません（2026-10-11 会長）。
    document.querySelectorAll('summary, .accordion__button').forEach(function (e) {
      if (e.getAttribute('data-oo-ja')) return;
      var walker = document.createTreeWalker(e, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        var raw = (node.nodeValue || '').trim();
        if (!raw) continue;
        var up = raw.toUpperCase();
        for (var i = 0; i < WORDS.length; i += 1) {
          if (up === WORDS[i][0]) {
            node.nodeValue = node.nodeValue.replace(raw, WORDS[i][1]);
            e.setAttribute('data-oo-ja', '1');
            return;
          }
        }
      }
    });
  }

  /* カートに OODAY の1行を出します
     （言いかえと「適用されています」の出し分けは shop6.js） */
  function cartNote() {
    if (!isCart() || Date.now() > OODAY_END) return;
    if (document.querySelector('.oo-ooday-note')) return;
    var btn = document.querySelector('[name="checkout"]');
    if (!btn) return;
    var p = document.createElement('p');
    p.className = 'oo-ooday-note oo-ooday-note--cart';
    p.textContent = OODAY_NOTE;
    btn.insertAdjacentElement('beforebegin', p);
  }

  /* ---------------------------------------------------------------
     パンくずに「シリーズ」を足す
     ★ほかのシリーズを足すときは、この表に
       ['商品名に入っている字', 'コレクションの合言葉'] を追加してください。
     ★スマホではテーマがパンくずごと隠していたので、shop5.css で出しています。
     --------------------------------------------------------------- */
  var SERIES = [
    ['Turbo GT', 'old-order-turbo-gt'],
    ['Turbo Lite', 'old-order-turbo-lite'],
    ['Turbo Urban', 'turbo-urban-1'],
    ['Turbo 2000', 'old-order-turbo-2000'],
    ['Turbo S', 'old-order-turbo-s'],
    ['Resculpt', 'old-order-resculpt'],
    ['OBread', 'old-order-obread-1'],
    ['OGoal', 'ogoal'],
    ['Oboot', 'old-order-oboot'],
    ['Smile O', 'old-order-smilo'],
    ['Division', 'old-order-division'],
    ['Canvas', 'old-order-canvas']
  ];

  function breadcrumb() {
    if (!isOldOrder()) return;
    var bc = document.querySelector('.breadcrumbs, [class*="breadcrumb"]');
    if (!bc || bc.querySelector('[data-oo-series]')) return;
    var title = ((document.querySelector('h1.product__title, h1') || {}).textContent || '').toLowerCase();
    var hit = null;
    for (var i = 0; i < SERIES.length; i += 1) {
      if (title.indexOf(SERIES[i][0].toLowerCase()) >= 0) { hit = SERIES[i]; break; }
    }
    if (!hit) return;
    var links = bc.querySelectorAll('a');
    if (!links.length) return;
    var last = links[links.length - 1];
    var host = (last.parentElement && last.parentElement !== bc) ? last.parentElement : last;
    var clone = host.cloneNode(true);
    var a = (clone.tagName === 'A') ? clone : clone.querySelector('a');
    if (!a) return;
    a.setAttribute('href', '/collections/' + hit[1]);
    a.textContent = hit[0];
    clone.setAttribute('data-oo-series', '1');
    host.insertAdjacentElement('afterend', clone);
    //   区切りの「/」は別の札なので、これも写して前に入れます
    var sep = bc.querySelector('.breadcrumbs__separator');
    if (sep && clone.parentNode) clone.parentNode.insertBefore(sep.cloneNode(true), clone);
  }

  /*   パンくずのいちばん右は検索用の題名がそのまま出ていて
       「Turbo GT ホワイトシルバー｜OLD ORDER JAPAN 公式」と長くなっていました。 */
  function breadcrumbTidy() {
    var bc = document.querySelector('.breadcrumbs, [class*="breadcrumb"]');
    if (!bc) return;
    var lis = bc.querySelectorAll('li');
    if (!lis.length) return;
    var last = lis[lis.length - 1];
    if (last.getAttribute('data-oo-tidy')) return;
    last.setAttribute('data-oo-tidy', '1');
    var t = (last.textContent || '').trim();
    var i = t.indexOf('｜');
    if (i > 0) t = t.slice(0, i).trim();
    //   商品名が長いと3行に折り返すので18字で切ります（いま見ているページなので短くてよい）
    if (t.length > 18) t = t.slice(0, 17) + '…';
    last.textContent = t;
  }

  /* ---------------------------------------------------------------
     サイズの目安の1行を作り替える（2026-10-11 会長）

     もとは「ふだん 26.5cm の方は 42。…」＋赤字「サイズ交換はお受けできません」。
     どの商品も同じ文で意味が伝わらず、赤字も怖いというご指摘でした。
     代わりに、商品説明の中にサイズ表がある商品だけ
     「サイズの選び方・スタッフの着用サイズ ＞」を小さく出し、押すとその表まで動かします。
     表が無い商品では、この1行ごと消します。
     --------------------------------------------------------------- */
  function sizeTable() {
    var picker = document.querySelector('.product__variant-picker');
    var hit = null;
    document.querySelectorAll('p, h2, h3, h4, strong, b').forEach(function (e) {
      if (hit || e.children.length > 1) return;
      if (picker && picker.contains(e)) return;            // サイズのボタンの枠は見ない
      var t = (e.textContent || '').replace(/\s+/g, '');
      if (!t || t.length > 20) return;
      if (/^[▼▽■◆●・]*(SIZE|サイズ|サイズ表|スタッフ着用|着用サイズ)/i.test(t)) hit = e;
    });
    return hit;
  }

  function sizeGuideV2() {
    var g = document.querySelector('.oo-size-guide');
    if (!g || g.getAttribute('data-oo-v2')) return;
    var target = sizeTable();
    if (!target) {
      //   説明がまだ出ていないこともあるので、しばらくは消さずに待ちます
      if (!g.getAttribute('data-oo-wait')) { g.setAttribute('data-oo-wait', '1'); return; }
      g.setAttribute('data-oo-v2', '1');
      if (g.parentNode) g.parentNode.removeChild(g);       // 表が無い商品は何も出さない
      return;
    }
    g.setAttribute('data-oo-v2', '1');
    g.innerHTML = '';
    var a = document.createElement('a');
    a.className = 'oo-size-jump';
    a.href = '#';
    a.textContent = 'サイズの選び方・スタッフの着用サイズ ＞';
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var det = target.closest('details');                 // 折りたたまれていたら開く
      if (det && !det.open) det.open = true;
      setTimeout(function () {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 240);
    });
    g.appendChild(a);
  }

  /* ---------------------------------------------------------------
     売り切れのサイズで行き止まりにしない

     OLD ORDER は色ちがいが別の商品として並んでいます（a.brandnav-colors__item）。
     サイズを選んだら、そのサイズが無い色をうすくし、
     売り切れのサイズを押したら、そのサイズがある色をその場に並べます。
     在庫は /products/〇〇.js から、サイズを押したときに初めて取りに行きます。
     --------------------------------------------------------------- */
  var stock = null;
  var busy = false;

  function colorLinks() {
    return Array.prototype.slice.call(document.querySelectorAll('a.brandnav-colors__item'));
  }

  function loadStock(done) {
    if (stock) { done(); return; }
    if (busy) return;
    var links = colorLinks();
    if (!links.length) { stock = {}; done(); return; }

    var key = 'oo_stock_' + location.pathname;
    try {
      var saved = sessionStorage.getItem(key);
      if (saved) { stock = JSON.parse(saved); done(); return; }
    } catch (e) {}

    busy = true;
    var box = {};
    var left = links.length;
    links.forEach(function (a) {
      var href = (a.getAttribute('href') || '').split('?')[0];
      var finish = function () {
        left -= 1;
        if (left > 0) return;
        stock = box;
        busy = false;
        try { sessionStorage.setItem(key, JSON.stringify(box)); } catch (e) {}
        done();
      };
      fetch(href + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var map = {};
          (p.variants || []).forEach(function (v) {
            var m = (v.title || '').match(/(\d{2})/);
            if (m) map[m[1]] = !!v.available;
          });
          box[href] = map;
        })
        .catch(function () {})
        .then(finish, finish);
    });
  }

  function colorDim(eu) {
    colorLinks().forEach(function (a) {
      var href = (a.getAttribute('href') || '').split('?')[0];
      var map = stock ? stock[href] : null;
      var cell = a.closest('.brandnav-colors__cell') || a;
      //   いま見ている色はうすくしない（今どこにいるかが分からなくなるため）
      if (!eu || !map || a.classList.contains('is-current')) {
        cell.classList.remove('oo-color-out');
        a.removeAttribute('title');
        return;
      }
      var out = (map[eu] !== true);
      cell.classList.toggle('oo-color-out', out);
      if (out) a.setAttribute('title', eu + ' は、この色はただ今品切れです');
      else a.removeAttribute('title');
    });
  }

  function altClear() {
    var old = document.querySelector('.oo-size-alt');
    if (old && old.parentNode) old.parentNode.removeChild(old);
  }

  function sizeAlt(eu) {
    altClear();
    var picker = document.querySelector('.product__variant-picker');
    if (!picker || !stock) return;
    var here = location.pathname.split('?')[0];
    var have = [];
    colorLinks().forEach(function (a) {
      var href = (a.getAttribute('href') || '').split('?')[0];
      if (href === here) return;
      var map = stock[href];
      if (map && map[eu] === true) {
        have.push({ href: href, name: (a.innerText || '').replace(/\s+/g, ' ').trim() || 'この色' });
      }
    });

    var box = document.createElement('div');
    box.className = 'oo-size-alt';
    var html;
    if (!have.length) {
      html = '<p class="oo-size-alt__t">' + eu + ' は、ほかの色もただ今品切れです。'
        + '<br>入荷のご予定はお問い合わせください。</p>';
    } else {
      html = '<p class="oo-size-alt__t">' + eu + ' は、こちらの色でご用意があります</p>'
        + '<ul class="oo-size-alt__list">';
      have.slice(0, 8).forEach(function (c) {
        html += '<li><a href="' + c.href + '">' + c.name + '</a></li>';
      });
      html += '</ul>';
    }
    box.innerHTML = html;
    picker.appendChild(box);
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /* サイズの札を押したときの見張り。
     売り切れの札を押しても Shopify は選ばないので、押した札が本当に選ばれたかで見分けます。 */
  function watchSizes() {
    if (!document.querySelector('.product__variant-picker')) return;
    document.addEventListener('click', function (e) {
      var lb = e.target.closest ? e.target.closest('.product-option__label') : null;
      if (!lb || !lb.getAttribute('data-oo-cm')) return;
      var id = lb.getAttribute('for');
      var made = lb.querySelector('.oo-size-eu');
      var raw = (lb.textContent || '').trim().match(/(^|\s)(\d{2})(\s|$)/);
      var eu = made ? made.textContent.trim() : (raw ? raw[2] : null);
      if (!eu) return;
      setTimeout(function () {
        var inp = id ? document.getElementById(id) : null;
        if (inp && inp.checked) {
          altClear();
          loadStock(function () { colorDim(eu); });
        } else {
          loadStock(function () { colorDim(eu); sizeAlt(eu); });
        }
      }, 400);
    }, true);
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    fixHeads();
    fixSama();
    cartNote();
    breadcrumb();
    breadcrumbTidy();
    sizeGuideV2();
    watchSizes();

    /* あとから読み込まれて出てくるものがあるので、600ms おきに30回（18秒）見直します。 */
    var tries = 0;
    var timer = setInterval(function () {
      fixHeads();
      fixSama();
      cartNote();
      breadcrumb();
      breadcrumbTidy();
      sizeGuideV2();
      tries += 1;
      if (tries >= 30) clearInterval(timer);
    }, 600);

    /* 横から出るカートの引き出しは、ページを開いたずっとあとに開くことがあります。 */
    if (window.MutationObserver) {
      var moTimer = null;
      new MutationObserver(function () {
        clearTimeout(moTimer);
        moTimer = setTimeout(fixSama, 250);
      }).observe(document.body, { childList: true, subtree: true });
    }
  });
})();